import { SvgIconTypeMap, SxProps, Tooltip } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import React, { ReactNode } from 'react';

interface BkToolTipProps {
  title: string | ReactNode;
  Icon: OverridableComponent<SvgIconTypeMap<{}, 'svg'>> & {
    muiName: string;
  };
  placement?:
    | 'top'
    | 'bottom-end'
    | 'bottom-start'
    | 'bottom'
    | 'left-end'
    | 'left-start'
    | 'left'
    | 'right-end'
    | 'right-start'
    | 'right'
    | 'top-end'
    | 'top-start';
  sx?: SxProps;
}

const BkToolTip: React.FC<BkToolTipProps> = ({
  title,
  Icon,
  placement = 'top',
  sx,
}) => {
  return (
    <Tooltip
      title={title}
      placement={placement}
      sx={{ cursor: 'pointer', color: '#7E828B', fontSize: '1.25rem', ...sx }}
    >
      <Icon />
    </Tooltip>
  );
};

export default BkToolTip;
